import React, { useRef, useContext, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, Page } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../../components/global/appContext";
import { TitleBar } from "@shopify/app-bridge-react";
import lmsAPI from "../../../../services/lmsAPI";

export default function MapIndex(props) {
  const { t } = useTranslation();
  async function fetchLocations() {
    const res = await lmsAPI.get("/locations/coordinates");
    return res.data;
  }
  const { data, isError, isFetching } = useQuery(
    ["locationCoords"],
    fetchLocations,
    {
      onSuccess: () => {},
    }
  );

  const appContext = useContext(AppContext);
  mapboxgl.accessToken = appContext.mapboxAdminToken;
  const mapContainer = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const map = useRef(null);

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/light-v10",
      center: [0, 0],
      zoom: 1,
    });
    map.current.on("load", () => setMapLoaded(true));
  }, []);

  useEffect(() => {
    if (!mapLoaded) return; // Wait for map to load
    if (!data) return; // Wait for location data
    if (!data.length) return;

    // Fit map to locations
    const lngs = data.map((coords) => coords.lng);
    const lats = data.map((coords) => coords.lat);
    const northEast = [Math.max(...lngs), Math.max(...lats)];
    const southWest = [Math.min(...lngs), Math.min(...lats)];

    map.current.fitBounds([southWest, northEast], {
      padding: 50,
      animate: false,
    });

    function coordsToGeoJson(locationData) {
      return {
        type: "FeatureCollection",
        features: locationData.map((location) => {
          return {
            type: "Feature",
            properties: {
              name: location.name,
              id: location.id,
            },
            geometry: {
              type: "Point",
              coordinates: [location.lng, location.lat],
            },
          };
        }),
      };
    }

    map.current.loadImage("/shop-icon.png", (error, image) => {
      map.current.addImage("store-icon", image);
      map.current.addSource("locations", {
        type: "geojson",
        data: coordsToGeoJson(data),
      });

      // Add a symbol layer
      map.current.addLayer({
        id: "locations-data",
        type: "symbol",
        source: "locations",
        layout: {
          "icon-image": "store-icon",
          "icon-size": 0.04,
          "icon-allow-overlap": false,
          "text-allow-overlap": false,
          "text-field": ["get", "name"],
          "text-variable-anchor": ["top", "bottom"],
          "text-size": 12,
          "text-radial-offset": 1,
        },
      });

      // map.on("click", "locations", (e) => {
      //   console.log(e);
      // });
    });
  }, [data, mapLoaded]);

  return (
    <>
      <TitleBar
        title={t("map.title")}
        breadcrumbs={[{ content: t("map.breadcrumbs.locations"), url: "/places/locations" }]}
      />
      <div class="location-map-container">
        <Page fullWidth>
          <Card>
            <div
              ref={mapContainer}
              className="map-container"
              style={{ height: "100%" }}
            />
          </Card>
        </Page>
      </div>
    </>
  );
}
